import { useGetLocaleYearMake } from "@dealer-center/inventory-pages-gvm-fetch";
import { Tabs } from "@dealer-center/core-components";
import React, { useEffect } from "react";
import styled from "styled-components";
import { ModelCreatorPage } from "./ModelCreator";
import { TrimCreatorPage } from "./TrimCreator";
import { LiveQueryPage } from "./LiveQuery";
import { useIsGvmRwAccessUser } from "./util/gvmUserUtil";
import type {
  TrimViewFormData,
  VehicleViewFormData
} from "@dealer-center/inventory-pages-gvm-interface";

const StyledGlobalVehicleManagerPage = styled.div`
  justify-content: center;
  text-align: center;
  width: 80vw;
`;

interface PagesGvmUiProps {
  editVehicle?: VehicleViewFormData;
  editTrim?: TrimViewFormData;
}

export const PagesGvmUi = ({ editVehicle, editTrim }: PagesGvmUiProps) => {
  const localeYearMakeSearchResponse = useGetLocaleYearMake();
  const isGvmRwAccessUser = useIsGvmRwAccessUser();

  useEffect(() => {
    document.title = "GVM";
  }, []);

  return (
    <StyledGlobalVehicleManagerPage>
      <h2 style={{ textAlign: "left" }}>Global Vehicle Manager</h2>

      <Tabs
        id="GVMTabs"
        tabs={[
          {
            component: (
              <LiveQueryPage editTrim={editTrim} editVehicle={editVehicle} />
            ),
            label: "Live Query",
            value: "live_query",
            active: true
          },
          {
            component: <ModelCreatorPage {...localeYearMakeSearchResponse} />,
            disabled: !isGvmRwAccessUser,
            label: "Model Creator",
            value: "model_creator",
            active: true
          },
          {
            component: <TrimCreatorPage {...localeYearMakeSearchResponse} />,
            disabled: !isGvmRwAccessUser,
            label: "Trim Creator",
            value: "trim_creator",
            active: true
          }
        ]}
      />
    </StyledGlobalVehicleManagerPage>
  );
};
